import { z } from 'zod';
import { bulkCreateUsers } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  email: z.string().email('Valid email is required'),
  username: z.string().optional().default(''),
  fullName: z.string().optional().default(''),
  phoneNumber: z.string().optional().default(''),
  platformRole: z.enum(['USER', 'MODERATOR', 'ADMINISTRATOR']).optional().default('USER'),
  primaryLocationSlug: z.string().optional().default(''),
});

export const userConfig: CsvEntityConfig = {
  entityName: 'Users',
  entityNameSingular: 'User',
  columns: [
    { key: 'email', label: 'Email', required: true, description: 'User email address', exampleValue: 'user@example.com' },
    { key: 'username', label: 'Username', required: false, description: 'Unique username', exampleValue: 'john_doe' },
    { key: 'fullName', label: 'Full Name', required: false, description: 'Display name', exampleValue: 'John Doe' },
    { key: 'phoneNumber', label: 'Phone', required: false, description: 'Phone number', exampleValue: '+1234567890' },
    { key: 'platformRole', label: 'Platform Role', required: false, description: 'USER, MODERATOR, or ADMINISTRATOR (default: USER)', exampleValue: 'USER' },
    { key: 'primaryLocationSlug', label: 'Primary Location Slug', required: false, description: 'Slug of primary location', exampleValue: '' },
  ],
  validationSchema,
  exampleRows: [
    { email: 'admin@example.com', username: 'admin_user', fullName: 'Admin User', phoneNumber: '+1234567890', platformRole: 'ADMINISTRATOR', primaryLocationSlug: '' },
    { email: 'member@example.com', username: 'member1', fullName: 'Community Member', phoneNumber: '', platformRole: 'USER', primaryLocationSlug: '' },
  ],
  bulkCreateAction: bulkCreateUsers as any,
  importNotes: [
    'Users created via bulk upload will NOT have login credentials.',
    'They must register through the normal auth flow to set a password.',
    'Primary Location Slug must reference an existing location.',
  ],
};



